import { useAuthStore } from "@/ai_studio/stores/auth";

const AuthResolver = async (to, from, next) => {
  const authStore = useAuthStore();
  const redirectUrl = to.query.url || "/";
  const jwt = to.params.jwt;
  try {
    const authenticated = await authStore.login(jwt, redirectUrl);
    if (!authenticated) {
      throw new Error("Authentication failed.");
    }
    return next({ path: redirectUrl, replace: true });
  } catch (err) {
    authStore.logout();
    return next({ path: "/403", replace: true });
  }
};

export default AuthResolver;
